import { render, staticRenderFns } from "./Perfil.vue?vue&type=template&id=8f0de3c6&"
import script from "./Perfil.vue?vue&type=script&lang=js&"
export * from "./Perfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QList,QItem,QItemSection,QItemLabel,QIcon,QSeparator,QBtn,QCardActions,QTooltip,Ripple} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QList,QItem,QItemSection,QItemLabel,QIcon,QSeparator,QBtn,QCardActions,QTooltip})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {Ripple})
